import { render, staticRenderFns } from "./propaganda.vue?vue&type=template&id=170dbcb4&scoped=true"
import script from "./propaganda.vue?vue&type=script&lang=js"
export * from "./propaganda.vue?vue&type=script&lang=js"
import style0 from "./propaganda.vue?vue&type=style&index=0&id=170dbcb4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170dbcb4",
  null
  
)

export default component.exports